export const tool = {
  name: 'clear-scene',
  description: 'A tool that clears the scene of all 3D models.',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      message: {
        type: 'string',
        default: 'Add selected model to the scene',
      },
    },
    required: ['message'],
  },
};
